// React for Website

import React from "react";
//outsource
import { Row, Col, Form, DatePicker } from "antd";

//components

const StaffDateOfBirth = ({ disabled }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------

  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      name="dob"
      label="Date of birth"
      // rules={[
      //   {
      //     required: true,
      //     message: "Please select date",
      //   },
      // ]}
    >
      <DatePicker
        style={{ width: "100%" }}
        placeholder="Select date"
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default StaffDateOfBirth;
